import { post } from '..';
import routes from './routes';

const AuthServices = {
  login: async (obj) => {
    const data = await post(routes.login, obj);
    return data;
  },
  logout: async (obj) => {
    const data = await post(routes.logout, obj);
    return data;
  },
  forgotPassword: async (obj) => {
    const data = await post(routes.forgotPassword, obj);
    return data;
  },
  resetPassword: async (token, obj) => {
    const data = await post(routes.resetPassword + token, obj);
    return data;
  },
  changePassword: async (obj) => {
    const data = await post(routes.changePassword, obj);
    return data;
  },
}

export default AuthServices